module.exports = __webpack_public_path__ + "static/media/QuestionIcon.54878c7d.svg";